<section class="tab-content clr-col-12" [ngClass]="{'d-none': !isActive || disabled || justAButton}">
    <ng-content *ngIf="!_lazyContent"></ng-content>
    <ng-container #viewOutlet></ng-container>
</section>
